import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { store } from "./redux-thunk/store";
import { HashRouter as Router } from "react-router-dom";
import Views from "./views";
import { Route, Switch } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from "./configs/AppConfig";
import { setBaseUrl } from "configs/setBaseUrl";
import Loading from "components/shared-components/Loading";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css?v=1`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css?v=1`,
};

function App() {
  const [baseUrlReady, setBaseUrlReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    setBaseUrl().finally(() => {
      if (mounted) setBaseUrlReady(true);
    });
    return () => {
      mounted = false;
    };
  }, []);

  if (!baseUrlReady) {
    return <Loading cover="page" />;
  }

  return (
    <div className="App">
      <Provider store={store}>
        <ThemeSwitcherProvider
          themeMap={themes}
          defaultTheme={THEME_CONFIG.currentTheme}
          insertionPoint={document.getElementById("styles-insertion-point")}
        >
          <Router>
            <Switch>
              <Route path="/" component={Views} />
            </Switch>
          </Router>
        </ThemeSwitcherProvider>
      </Provider>
    </div>
  );
}

export default App;
